// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ExpandArrow_wrapper__AhErs","icon":"ExpandArrow_icon__d98RD","opened":"ExpandArrow_opened__OlAe8"};